import { finish, error } from '../../../modules/customers/actions/set-limit';

import api from '../../../api';

export function request(dispatch, { id, period, amount }) {
    api.put('/customers/' + id + '/deposit-limits', { period, amount: amount * 100 }).then(
        () => api.get('/customers/' + id).then(
            (customer) => dispatch(finish(id, period, customer)),
            () => dispatch(finish(id, period))
        ),
        ({ errors }) => dispatch(error(id, period, errors))
    );
}
